import React from "react";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProjectSummaryVM } from "../../api/generated/models";
import { PackageSummary } from "../../api/models";
import { EBadgeStatuses } from "../../shared/enums/phases.enums";
import { UseHistoryType } from "../../shared/types/routing.types";
import { isNullOrUndefined } from "../../shared/utils/data.utils";

const getBadgeFormat = (
  status: string
): { colorFlag: string; label: string } => {
  let colorFlag;
  let label;
  switch (status.toUpperCase()) {
    case EBadgeStatuses.AT_RISK:
      colorFlag = "success";
      label = "ON TIME";
      break;
    case EBadgeStatuses.CRITICAL:
      colorFlag = "warning";
      label = "PENDING";
      break;
    case EBadgeStatuses.ON_TIME:
      colorFlag = "success";
      label = "ON TIME";
      break;
    default:
      colorFlag = "primary";
      label = "";
      break;
  }

  return { colorFlag, label };
};

const navigateToUrl = (
  history: UseHistoryType,
  project: ProjectSummaryVM,
  packages?: Array<PackageSummary> | null
) => {
  /* istanbul ignore next */
  if (packages && packages.length) {
    history.push(
      `/project-details/${project.projectId}?packageId=${packages[0].packageId}`
    );
  } else {
    history.push(`/project-details/${project.projectId}`);
  }
};

// istanbul ignore next
const renderEmailLink = (
  name: string | null | undefined,
  email: string | null | undefined,
  projectId: string | null | undefined,
  projectTitle: string | null | undefined,
  sendDataToGTM: any
): React.ReactNode => {
  const isEmptyString = /^ *$/;

  if (
    isNullOrUndefined(email) &&
    (isNullOrUndefined(name) || isEmptyString.test(name))
  ) {
    return null;
  }

  if (isNullOrUndefined(name) || isEmptyString.test(name)) {
    if (isNullOrUndefined(email)) {
      return null;
    } else {
      return (
        <a
          className="details-stack-email"
          href={
            email
              ? `mailto:${email}?subject=${encodeURIComponent(
                  `[${projectId}] ${projectTitle}`
                )}`
              : ""
          }
          onClick={() => {
            sendDataToGTM({
              event: "eventTracking",
              category: "Construction",
              action: "Click - View Projects",
              label: "Coordinator Email",
            });
          }}
        >
          {email}
        </a>
      );
    }
  } else {
    if (isNullOrUndefined(email)) {
      return <span>{name}</span>;
    } else
      return (
        <a
          className="details-stack-email"
          href={
            email
              ? `mailto:${email}?subject=${encodeURIComponent(
                  `[${projectId}] ${projectTitle}`
                )}`
              : ""
          }
          onClick={() => {
            sendDataToGTM({
              event: "eventTracking",
              category: "Construction",
              action: "Click - View Projects",
              label: "Coordinator Email",
            });
          }}
        >
          {name}
          <FontAwesomeIcon className="envelope-icon" icon={faEnvelope} />
        </a>
      );
  }
};

export default { getBadgeFormat, navigateToUrl, renderEmailLink };
